<div class="confirmation-container">

	<!-- ── Header ─────────────────────────────────────────── -->
	<div class="confirmation-header">
		<i class="mdi mdi-check-circle-outline success-icon"></i>
		<h3 class="f-h3 success-title">
			{{ (isNewRequest ? 'REQUEST_SUBMITTED_TITLE' : 'REQUEST_UPDATED_TITLE') | translate }}
		</h3>
	</div>

	<!-- ── New request: case number + next-steps ──────────── -->
	<ng-container *ngIf="isNewRequest">
		<div class="confirmation-details" *ngIf="requestId">
			<span class="case-label">{{ 'CASE_NUMBER_LABEL' | translate }}</span>
			<div class="case-number" [attr.aria-label]="'Case number: ' + requestId">{{ requestId }}</div>
		</div>
		<div class="confirmation-details" *ngIf="!requestId">
			<p class="f-body-s secondary-message">{{ 'CASE_NUMBER_EMAIL_NOTE' | translate }}</p>
		</div>

		<div class="next-steps">
			<p class="next-steps__title">{{ 'WHAT_HAPPENS_NEXT' | translate }}</p>
			<div class="steps-list">
				<div class="step-item">
					<div class="step-number">1</div>
					<p class="step-text">{{ 'NEXT_STEP_1' | translate }}</p>
				</div>
				<div class="step-item">
					<div class="step-number">2</div>
					<p class="step-text">{{ 'NEXT_STEP_2' | translate }}</p>
				</div>
				<div class="step-item">
					<div class="step-number">3</div>
					<p class="step-text">{{ 'NEXT_STEP_3' | translate }}</p>
				</div>
				<div class="step-item">
					<div class="step-number">4</div>
					<p class="step-text">{{ 'NEXT_STEP_4' | translate }}</p>
				</div>
			</div>
		</div>
	</ng-container>

	<!-- ── Update: case number + what's next ──────────────── -->
	<ng-container *ngIf="!isNewRequest">
		<div class="confirmation-details" *ngIf="requestId">
			<span class="case-label">{{ 'CASE_NUMBER_LABEL' | translate }}</span>
			<div class="case-number" [attr.aria-label]="'Case number: ' + requestId">{{ requestId }}</div>
		</div>

		<div class="next-steps">
			<p class="next-steps__title">{{ 'WHAT_HAPPENS_NEXT' | translate }}</p>
			<div class="steps-list">
				<div class="step-item">
					<div class="step-number">1</div>
					<p class="step-text">{{ 'UPDATED_STEP_1' | translate }}</p>
				</div>
				<div class="step-item">
					<div class="step-number">2</div>
					<p class="step-text">{{ 'UPDATED_STEP_2' | translate }}</p>
				</div>
			</div>
		</div>
	</ng-container>

	<!-- ── Actions ────────────────────────────────────────── -->
	<div class="form-actions">
		<button class="btn btn--primary btn--lg full-width"
				(click)="goToLogin()">
			{{ 'RETURN_TO_LOGIN' | translate }}
		</button>
	</div>

</div>
